import * as angular from 'angular';

import { ComponentDefinition, IValueViewModel } from '../../models';

class TagNameDisplayController implements angular.IComponentController {
    readonly isEditMode: boolean;
    readonly tag: IValueViewModel;

    static $inject = [];
}

export const wtTagNameDisplay: ComponentDefinition = {
    componentId: 'wtTagNameDisplay',
    controller: TagNameDisplayController,
    template: require('./tagNameDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        isEditMode: '<?',
        tag: '<'
    }
};